import { slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { forwardRef, useContext } from 'react';
import { PopoverContext, OverlayTriggerStateContext } from 'react-aria-components';
import { useOverlayTriggerState } from 'react-stately';
import PopoverInner from './popover-inner.esm.js';
import { useContextProps, useExitAnimation, HiddenContext } from '../../utils/index.esm.js';

function Popover(props, ref) {
  var _useContextProps = useContextProps(props, ref, PopoverContext);
  var _useContextProps2 = _slicedToArray(_useContextProps, 2);
  props = _useContextProps2[0];
  ref = _useContextProps2[1];
  var contextState = useContext(OverlayTriggerStateContext);
  var localState = useOverlayTriggerState(props);
  var state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
  var isExiting = useExitAnimation(ref, state.isOpen) || props.isExiting || false;
  var isHidden = useContext(HiddenContext);

  // If we are in a hidden tree, we still need to preserve our children.
  if (isHidden) {
    var children = props.children;
    if (typeof children === 'function') {
      children = children({
        trigger: props.trigger || null,
        placement: 'bottom',
        isEntering: false,
        isExiting: false,
        defaultChildren: null
      });
    }
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
  }
  if (state && !state.isOpen && !isExiting) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(PopoverInner, _extends({}, props, {
    triggerRef: props.triggerRef,
    state: state,
    popoverRef: ref,
    isExiting: isExiting
  }));
}

/**
 * A popover is an overlay element positioned relative to a trigger.
 */
var _Popover = /*#__PURE__*/forwardRef(Popover);
var AriaPopover = _Popover;

export { AriaPopover as default };
//# sourceMappingURL=popover.esm.js.map
